import { useQuery } from '@tanstack/react-query';
import { getSharedStartupProfile } from '../api/shared-profile.api';

/** Load the read-only Startup Profile for a verified recipient (MYN-41/58). */
export function useSharedProfileView(token: string) {
  return useQuery({
    queryKey: ['shared-profile', token, 'profile'],
    queryFn: () => getSharedStartupProfile(token),
    retry: false,
  });
}
